module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp1_9005.96450a2d.png";